import { AuthConfig } from 'angular-oauth2-oidc';
import {environment} from "../../environments/environment";

export const authConfig: AuthConfig = {
  issuer: environment.oAuthProviderEndpoint,
  loginUrl: environment.oAuthProviderEndpoint + '/authorize',
  logoutUrl: environment.oAuthProviderEndpoint + '/oauthlogout',
  tokenEndpoint: environment.oAuthProviderEndpoint + '/token',
  redirectUri: environment.oAuthRedirectUri,
  useSilentRefresh: false,
  strictDiscoveryDocumentValidation: false,
  clientId: 'fece9397abff89a1f4bf8f480a906e9c',
  scope: 'defaultscope',
  responseType: 'code',
  requireHttps: false,
  showDebugInformation: true,
  oidc: false,
  requestAccessToken: true,
  dummyClientSecret: "f2133b1cc0c13609b40bab62b708ce17770ef705d66f10192deb36104fe65f05d49baf1b728165df19f47694e2b5b6c1a5180ea8ed052730c59146bdb8f5f903",
};
